import { render } from "./HowCanWeHelpCard.vue?vue&type=template&id=091675f0&scoped=true&ts=true"
import script from "./HowCanWeHelpCard.vue?vue&type=script&lang=ts"
export * from "./HowCanWeHelpCard.vue?vue&type=script&lang=ts"

import "./HowCanWeHelpCard.vue?vue&type=style&index=0&id=091675f0&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091675f0"]])

export default __exports__